<a [routerLink]="url" [queryParamsHandling]="'preserve'">
  <div [ngClass]="backgroundClass">
    <svg width="8px" height="13px">
      <path
        fill-rule="evenodd"
        fill="rgb(35, 47, 58)"
        d="M8.000,1.363 L6.611,-0.002 L-0.002,6.499 L6.611,13.000 L8.000,11.635 L2.776,6.499 L8.000,1.363 Z"
      />
    </svg>
  </div>
  <span>Back To {{ title }}</span>
</a>
